import type { CheckResult } from '@/graphql/generated';

export type CheckResultLike = Pick<
	CheckResult,
	'success' | 'errorCode' | 'errorDescription'
>;

export const extractCheckResultError = (
	result?: CheckResultLike | null
): string | null => {
	if (!result) {
		return 'Request failed. Please try again.';
	}

	if (result.success) {
		return null;
	}

	return result.errorDescription ?? result.errorCode ?? 'Request failed.';
};
